import React from "react";
import { AuthLayout } from "../../../components";
import CurrentPlanPage from "./planpage";

function PlanPage() {
  return (
    <AuthLayout mx="12"  top="0.1rem" url="/media/login/plan_footer.png">
      <CurrentPlanPage />
    </AuthLayout>
  );
}

export default PlanPage;
